export default __webpack_public_path__ + "static/media/avatar-1.1f0c7cbb.png";